import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ThemeService } from '@wind-log_library/fe-component-library';

@Pipe({
    name: 'themeColor',
    standalone: false
})

export class ThemeColorPipe implements PipeTransform {

  constructor(private themeService: ThemeService) {
  }

  public transform(colorKey: string): Observable<string> {
    return this.themeService.getTheme().pipe(
      map(() => this.themeService.getColor(colorKey))
    );
  }
}

